import { LicenseResponse } from "../models/responses/LicenseResponse";
import { License } from "../../common/models/License";
import { LicenseCategoryMapper } from "./LicenseCategoryMapper";

export const LicenseMapper = (data: LicenseResponse): License => {
  return {
    categories: data.categories.map(cat => LicenseCategoryMapper(cat)),
    expeditionDate: data.expeditionDate,
    expiredYear: data.expiredYear,
    image: data.image,
    licenseNumber: data.licenseNumber 
  }
}